export default {
    topics: [
        {
            title: ' DeleteService ',
            href: 'sm-subscription-DeleteService.html',
            attributes: { 'data-id': 'sm-subscription-DeleteService' },
            menu: { hasChildren: false },
            tocID: 'sm-subscription-DeleteService-d66e3895',
            topics: [],
        },
        {
            title: ' RecipientSubscribe ',
            href: 'sm-subscription-RecipientSubscribe.html',
            attributes: { 'data-id': 'sm-subscription-RecipientSubscribe' },
            menu: { hasChildren: false },
            tocID: 'sm-subscription-RecipientSubscribe-d66e3903',
            topics: [],
        },
        {
            title: ' SendConfirmation ',
            href: 'sm-subscription-SendConfirmation.html',
            attributes: { 'data-id': 'sm-subscription-SendConfirmation' },
            menu: { hasChildren: false },
            tocID: 'sm-subscription-SendConfirmation-d66e3911',
            topics: [],
        },
        {
            title: ' Subscribe ',
            href: 'sm-subscription-Subscribe.html',
            attributes: { 'data-id': 'sm-subscription-Subscribe' },
            menu: { hasChildren: false },
            tocID: 'sm-subscription-Subscribe-d66e3919',
            topics: [],
        },
        {
            title: ' Unsubscribe ',
            href: 'sm-subscription-Unsubscribe.html',
            attributes: { 'data-id': 'sm-subscription-Unsubscribe' },
            menu: { hasChildren: false },
            tocID: 'sm-subscription-Unsubscribe-d66e3927',
            topics: [],
        },
    ],
};

